"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.fields = exports["default"] = exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _config = require("../../config.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['id', 'label', 'showTargetLabel', 'allowUserItem', 'maxUserItems', 'min', 'max', 'correctItems', 'isDisabled'];
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (values.min !== undefined && values.min < 0) {
    errors.min = 'Min should be a positive number';
  }
  if (values.max !== undefined && values.max < 1) {
    errors.max = 'Max should be more than 1';
  }
  if (values.min && values.max && values.min > values.max) {
    errors.min = 'Min should be not more than max';
  }
  if (values.maxUserItems && (typeof values.maxUserItems !== 'number' || values.maxUserItems < 1 || values.maxUserItems > _config.MAX_USER_ITEMS)) {
    errors.maxUserItems = "Value should be between 1 and ".concat(_config.MAX_USER_ITEMS);
  }
  return errors;
};
var Component = exports.Component = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "toggleCorrectItem", function (id) {
      var correctItems = _this.props.fields.correctItems;
      correctItems.onChange((0, _xor2["default"])(correctItems.value, [id]));
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$fields = this.props.fields,
        showTargetLabel = _this$props$fields.showTargetLabel,
        allowUserItem = _this$props$fields.allowUserItem,
        maxUserItems = _this$props$fields.maxUserItems,
        min = _this$props$fields.min,
        max = _this$props$fields.max,
        correctItems = _this$props$fields.correctItems,
        isDisabled = _this$props$fields.isDisabled;
      var _this$props$extraProp = this.props.extraProps.values,
        sources = _this$props$extraProp.sources,
        allowCorrectAnswers = _this$props$extraProp.allowCorrectAnswers;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showTargetLabel))), " Show target label")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(isDisabled))), " Disable user input")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        type: "number",
        field: min,
        label: "Min required items"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        type: "number",
        field: _objectSpread(_objectSpread({}, (0, _pick2["default"])(max, ['value', 'touched', 'error'])), {}, {
          onChange: function onChange(e) {
            var value = e.target.value;
            max.onChange(value === '' ? undefined : value);
          }
        }),
        label: "Max required items"
      }))), allowCorrectAnswers ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: correctItems,
        label: "Correct items"
      }, sources.map(function (source) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: source.id,
          className: "checkbox",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          checked: correctItems.value && correctItems.value.includes(source.id),
          onChange: _this2.toggleCorrectItem.bind(_this2, source.id)
        }), ' ', (0, _cccisdSurveyCommon.stripTags)(source.label)));
      }))) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(allowUserItem))), " Allow user-added items")), allowUserItem.value ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '0.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: maxUserItems,
        label: "Max user-added items"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "number",
        className: "form-control",
        value: maxUserItems.value || 5,
        min: 1,
        max: _config.MAX_USER_ITEMS,
        onChange: function onChange(e) {
          return maxUserItems.onChange(Number(e.target.value));
        },
        style: {
          width: '6em'
        }
      }))) : null));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  fields: _propTypes["default"].object,
  extraProps: _propTypes["default"].object
});
var _default = exports["default"] = {
  name: 'Target',
  component: Component,
  validate: validate,
  fields: fields,
  initialValues: {
    showTargetLabel: true,
    min: 0,
    isDisabled: false
  }
};